import { Component } from "react";
class MapGoogle2 extends Component {
  id = "genericmap";
  type = "map";
  map = null;
  state = {
    isIdArray: false,
    init: false,
    container: false,
  };

  constructor(props) {
    super(props);
    this.id = this.props.id || `${this.id}`;
    this.type = this.props.type || this.type;
  }
  onScriptLoad = () => {
    this.setState({
      init: true,
      container: <div id={this.id} style={{ height: this.props.height }}></div>,
    });
  };

  crearVentanaIncrustada(func, map) {
    func(map, this.props.referencia);
  }

  componentDidUpdate(props, state) {
    if (this.state.init) {
      if (this.type === "heatmaplayer") {
        this.map = new window.google.maps.visualization.HeatmapLayer(
          document.getElementById(this.id),
          this.props.options
        );
      } else {
        this.map = new window.google.maps.Map(
          document.getElementById(this.id),
          this.props.options
        );
      }
      this.props.onMapLoad(this.map, window.google);
    }
  }

  componentDidMount() {
    if (!window.google) {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.src = `https://maps.google.com/maps/api/js?key=AIzaSyC5_bKVZPjdddZkv0IJeGPXPl8FNZOE-4M&libraries=visualization`;
      var x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
      // Below is important.
      //We cannot access google.maps until it's finished loading
      s.addEventListener("load", (e) => {
        this.onScriptLoad();
      });
    } else {
      this.onScriptLoad();
    }
  }

  render() {
    return this.state.init ? (
      this.state.container
    ) : this.props.loader ? (
      this.props.loader
    ) : (
      <h1>Cargando</h1>
    );
  }
}

export default MapGoogle2;
